"use strict";

const months = {
	fr : ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
	en : ['January','February','March','April','May','June','July','August','September','October','November','December']
};

const days = {
	fr : ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
	en : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
};

function prettyDate(lang, mode, date){
	if(typeof(date) == 'string' || Number.isInteger(date)) date = new Date(date);
	else if(!(date instanceof Date) || isNaN(date)) date = new Date();
	let prettyDay = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
	let prettyMonth = date.getMonth() + 1;
	if(prettyMonth < 10) prettyMonth = '0' + prettyMonth;
	if(mode == "text"){
		if(lang == 'fr') return days[lang][date.getDay()] + ' ' + prettyDay + ' ' + months[lang][date.getMonth()] + ' ' + date.getFullYear();
		else if (lang == 'en') return days[lang][date.getDay()] +', '+ months[lang][date.getMonth()] +' '+prettyDay+', '+date.getFullYear();
	} else if(mode == "digital") {
		if(lang == 'fr') return prettyDay + '/' + prettyMonth + '/' + date.getFullYear();
		else return prettyMonth + '/' + prettyDay + '/' + date.getFullYear();
	}
	else if(mode == "short") {
		if(lang == 'fr') return prettyDay + '/' + prettyMonth;
		else return prettyMonth + '/' + prettyDay;
	}
}

function dateToInput(date){
	if(!(date instanceof Date) || isNaN(date)) date = new Date();
	let month = date.getMonth() + 1;
	if(month < 10) month = '0' + month;
	let day = date.getDate() < 10 ? '0'+date.getDate() : date.getDate();
	return date.getFullYear()+'-'+month+'-'+day;
}

function orientation(){
	if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
		var overlay = document.getElementById("orientation");
		let orientation = screen.msOrientation || (screen.orientation || screen.mozOrientation || {}).type || (window.matchMedia("(orientation:landscape)").matches ? 'not' : 'portrait-primary');
		if(orientation && orientation != "default" && orientation.indexOf("portrait") == -1) overlay.style.display = "block";
		else overlay.style.display = "none";
	}
}

function scrollToElem(element){
	let form = document.getElementsByTagName('form');
	let lastSize = form.offsetHeight;
	if(!form || !form.length) return;
	form = form[1];

	function animationEnded() {
		let nextElem = element;
		let offsetFromForm = 0;
		while(nextElem && nextElem.nodeName != 'FORM'){
			offsetFromForm += nextElem.offsetTop;
			nextElem = nextElem.parentNode;
		}
		if(offsetFromForm > lastSize) form.scrollTop = offsetFromForm;
	}

	function waitEndResize(){
		setTimeout(function(){
			let currSize = form.offsetHeight;
			if(currSize == lastSize) return animationEnded();
			else {
				lastSize = currSize;
				return waitEndResize();
			}
		}, 200);
	}

	waitEndResize();
}

function askSyncData() {
	if ('serviceWorker' in navigator && window.navigator.onLine === true) {
		navigator.serviceWorker.ready.then(function(swRegistration) {
			if(swRegistration.sync && swRegistration.sync.register) return swRegistration.sync.register('dataSync');
			else if(navigator.serviceWorker.controller) navigator.serviceWorker.controller.postMessage({type:"fullSync"});
		});
	}
}
function pattern_icon() {
	const types = {
		text : 		"^[-'a-zA-ZÀ-ÖØ-öø-ÿ ]*[-'a-zA-ZÀ-ÖØ-öø-ÿ][-'a-zA-ZÀ-ÖØ-öø-ÿ ]*",
		email : 	"^[a-zA-Z0-9._%+-]+\@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$",
		number : 	"^[0-9_-]*$",
		tel : 		"^[\+0-9\\s_-]*$"
	}
	Array.from(document.getElementsByTagName("input")).forEach(function(input){
		const info = types[input.type];
		if(!info) return;
		if(!input.pattern) input.pattern = info;
		input.addEventListener("blur", function(){
			input.value = input.value.trim();
		});
		if(input.type == "email"){
			input.addEventListener("keypress", function(){
				if(event.keyCode == 32) event.preventDefault();
			});
		}
		const warning = document.createElement("div");
		warning.classList.add("icon");
		warning.classList.add("warning");
		input.parentNode.insertBefore(warning, input.nextSibling);
		const valid = document.createElement("div");
		valid.classList.add("icon");
		valid.classList.add("valid");
		input.parentNode.insertBefore(valid, warning);
	});
}

export default {
	prettyDate,
	dateToInput,
	orientation,
	scrollToElem,
	askSyncData,
	pattern_icon
}




// WEBPACK FOOTER //
// ./src/libs/main.js